// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1ga-T","title":"Images90_title__33PtG","images":"Images90_images__-SmQ_"};